import { useRouter } from 'next/router';

/**
 * `multiplexBuildingSessionId` from the current URL query (Pages Router).
 *
 * Next types `router.query` values as `string | string[] | undefined`. We collapse that to a single
 * `string | null` so callers can match `URLSearchParams#get`-style semantics and use simple null checks.
 *
 * Wait for `isReady` before treating the id as authoritative. The query can differ from the URL until
 * the client router has finished hydrating.
 */
const useMultiplexBuildingSessionId = () => {
  const router = useRouter();

  const multiplexBuildingSessionIdQueryValue = router.query.multiplexBuildingSessionId;

  const singleQueryValue = Array.isArray(multiplexBuildingSessionIdQueryValue)
    ? (multiplexBuildingSessionIdQueryValue[0] ?? null)
    : multiplexBuildingSessionIdQueryValue;

  const multiplexBuildingSessionId = singleQueryValue === undefined ? null : singleQueryValue;

  return { isReady: router.isReady, multiplexBuildingSessionId };
};

export default useMultiplexBuildingSessionId;
